module.exports = __webpack_public_path__ + "static/media/wordcloud_list_pruned.5f0b90e8.csv";